<template>
    <modal name="auction-history-modal"
           class="auction-history-modal"
           :pivotX="0.5"
           :pivotY="0.5"
           :adaptive="true"
           :width="'100%'"
           :height="'416px'"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
        <div class="auction_history_wrap">
            <div class="modal_header">
                <div class="modal_title">{{ $t('bid_history') }}</div>
                <div class="modal_close" @click="modalClose()"></div>
            </div>
            <item-list-history-component :item-type="'auctionHistory'"
                                         :market-key="m_idx"></item-list-history-component>

        </div>
    </modal>

</template>


<script>
import ItemListComponent from "@/components/item/ItemListComponent";
import ItemListHistoryComponent from "@/components/item/ItemListHistoryComponent";

export default {
    name: "AuctionHistoryModal",
    mixins: [],
    components: {
        ItemListHistoryComponent,
        ItemListComponent,
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            m_idx: '',
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        handlerBeforeOpen(event) {
            this.m_idx = event.params.m_idx;
        },
        handlerOpened() {
        },
        handlerBeforeClose() {
        },
        modalClose() {
            this.$modal.hide('auction-history-modal');
        },
        returnUrl() {
            return this.url
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
